import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { pageMetaTextProps } from '@/theme/sitePageTypography';

export function AiLeagueHeader(props: {
  userYouLine: ReactNode;
  leader: string | null;
  tournamentStarted: boolean;
}) {
  const { userYouLine, leader, tournamentStarted } = props;

  return (
    <HStack align='flex-start' justify='space-between' w='full' spacing={3}>
      <Box flex={1} minW={0}>
        {(userYouLine || (tournamentStarted && leader)) ? (
          <VStack align='stretch' spacing={0.5}>
            {userYouLine ? <Text {...pageMetaTextProps}>{userYouLine}</Text> : null}
            {tournamentStarted && leader ? (
              <Text {...pageMetaTextProps}>Leader: {leader}</Text>
            ) : null}
          </VStack>
        ) : null}
      </Box>
    </HStack>
  );
}
